package one.healthium.db.di

import one.healthium.db.DriverFactory
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

internal actual fun appDatabasePlatformModule() = module {
    singleOf(::DriverFactory)
}